import Vimeo from "@u-wave/react-vimeo";

import React, { useEffect, useState } from "react";

import styled from "styled-components";

const VideoGalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MainVideoContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const VideoThumbnails = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  overflow-x: auto;
  padding: 0 10px;
  box-sizing: border-box;
`;

const Thumbnail = styled.div`
  position: relative;
  width: 150px; /* Fixed width for all thumbnails */
  height: 100px; /* Fixed height for all thumbnails */
  cursor: pointer;
  overflow: hidden;
  flex-shrink: 0; /* Prevents thumbnails from shrinking to fit the container */

  &.active::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 20, 147, 0.5); /* Pink overlay */
  }
`;

const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures the image covers the thumbnail area without distortion */
`;

function VideoGallery({ items, activeTab }) {
  const [activeVideoId, setActiveVideoId] = useState(items[0].vimeoId);

  useEffect(() => {
    setActiveVideoId(items[0].vimeoId);
  }, [activeTab]);

  return (
    <VideoGalleryContainer className="video-gallery">
      <MainVideoContainer className="video-container">
        <Vimeo video={activeVideoId} autoplay responsive />
      </MainVideoContainer>
      <VideoThumbnails className="video-thumbnails">
        {items.map((video) => (
          <Thumbnail
            key={video.vimeoId}
            className={activeVideoId === video.vimeoId ? "active" : ""}
            onClick={() => setActiveVideoId(video.vimeoId)}
          >
            <ThumbnailImage
              src={video.imageUrl}
              alt={`Thumbnail for video ${video.vimeoId}`}
              className="thumbnail-image"
            />
          </Thumbnail>
        ))}
      </VideoThumbnails>
    </VideoGalleryContainer>
  );
}

export default VideoGallery;
